import { Loader2, X } from 'lucide-react'
import { ToastBar, Toaster, toast } from 'react-hot-toast'

export type ToastType = 'success' | 'error'
export const DEFAULT_DURATION = 7000
export const DEFAULT_POSITION = 'top-right'

export function ToastProvider() {
  return (
    <Toaster
      toastOptions={{
        duration: DEFAULT_DURATION,
        position: DEFAULT_POSITION,
        className: 'bg-white dark:!bg-gray-700 text-gray-900 dark:!text-white shadow-lg dark:!shadow-gray-900/50',
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => {
            if (t.type === 'loading') {
              return (
                <>
                  <Loader2 className="size-5 shrink-0 mr-2 animate-spin text-primary-600 dark:text-primary-400" />
                  {message}
                </>
              )
            }
            return (
              <>
                {icon}
                {message}
                <button
                  className="cursor-pointer ml-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                  onClick={() => toast.dismiss(t.id)}
                  aria-label="Close"
                >
                  <X className="size-5 shrink-0" />
                </button>
              </>
            )
          }}
        </ToastBar>
      )}
    </Toaster>
  )
}

export default ToastProvider
